import { Component,Input, OnInit, AfterViewInit,Pipe, PipeTransform, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { first } from 'rxjs/operators';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-pdf-cdn-viewer',
  templateUrl: './pdf-cdn-viewer.component.html',
  styleUrls: ['./pdf-cdn-viewer.component.scss']
})
export class PdfCdnViewerComponent implements OnInit {

  url : any = null;
  @Input() subitemId;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private el: ElementRef
  ) {
    
  }

  ngOnInit() {
    this.url =  environment.BACKEND_RACINE_URL+`gestion-fichier/download?subitemid=${this.subitemId}`
  }

}
